import { render, staticRenderFns } from "./SchoolCreateSchoolInfo.vue?vue&type=template&id=2b49aa74&"
import script from "./SchoolCreateSchoolInfo.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreateSchoolInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports